import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  signal,
} from "@angular/core";
import { getFlagUrl } from "../../utils/country-info.util";

@Component({
  selector: "app-flag",
  standalone: true,
  templateUrl: "./flag.component.html",
  styleUrl: "./flag.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlagComponent {
  readonly countryCode = input<string | null>(null);
  readonly countryName = input<string | null>(null);
  readonly size = input(20);
  private readonly failedUrl = signal<string | null>(null);
  readonly flagUrl = computed(() => getFlagUrl(this.countryCode()));
  readonly showImage = computed(
    () => !!this.flagUrl() && this.failedUrl() !== this.flagUrl(),
  );
  readonly fallbackText = computed(
    () =>
      this.countryName()?.trim() ||
      this.countryCode()?.trim().toUpperCase() ||
      "",
  );

  readonly height = () => Math.round(this.size() * 0.75);
  readonly altText = () => this.countryName() || this.countryCode() || "Flag";

  onError(): void {
    this.failedUrl.set(this.flagUrl());
  }
}
